import { Component, Inject, OnInit, inject, signal } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MaterialModule } from '../../material.module';

import { EquipmentsService } from '@app/shared/services/entities/equipments.service';
import { CustomMessageService } from '../../shared/components/custom-message/custom-message.service';

/** Datos de almacenamiento y dimensiones físicas de un equipo. */
export interface EquipmentStorageData {
  equipmentId: string;
  identifier?: string;
  storage_temp:       number | null;   // Temperatura de almacenamiento (°C)
  storage_humidity:   number | null;   // Humedad relativa de almacenamiento (%)
  storage_conditions: string | null;   // Notas / condiciones de almacenamiento
  dim_length:         number | null;   // Largo (cm)
  dim_width:          number | null;   // Ancho (cm)
  dim_height:         number | null;   // Alto (cm)
}

@Component({
  selector: 'app-equipment-storage-dialog',
  standalone: true,
  templateUrl: './equipment-storage-dialog.component.html',
  styleUrls: ['./equipment-storage-dialog.component.scss'],
  imports: [FormsModule, MatDialogModule, MaterialModule],
})
export class EquipmentStorageDialogComponent implements OnInit {

  private equipmentsService    = inject(EquipmentsService);
  private customMessageService = inject(CustomMessageService);

  saving = signal(false);

  // Modelo editable (ngModel).
  storage_temp:       number | null = null;
  storage_humidity:   number | null = null;
  storage_conditions: string | null = null;
  dim_length:         number | null = null;
  dim_width:          number | null = null;
  dim_height:         number | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EquipmentStorageData,
    public dialogRef: MatDialogRef<EquipmentStorageDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.storage_temp       = this.data.storage_temp ?? null;
    this.storage_humidity   = this.data.storage_humidity ?? null;
    this.storage_conditions = this.data.storage_conditions ?? null;
    this.dim_length         = this.data.dim_length ?? null;
    this.dim_width          = this.data.dim_width ?? null;
    this.dim_height         = this.data.dim_height ?? null;
  }

  private num(v: any): number | null {
    if (v === null || v === undefined || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  }

  async save(): Promise<void> {
    this.saving.set(true);
    const payload = {
      id:                 this.data.equipmentId,
      storage_temp:       this.num(this.storage_temp),
      storage_humidity:   this.num(this.storage_humidity),
      storage_conditions: (this.storage_conditions ?? '').toString().trim() || null,
      dim_length:         this.num(this.dim_length),
      dim_width:          this.num(this.dim_width),
      dim_height:         this.num(this.dim_height),
      operationType:      'single',
    };
    try {
      const resp = await this.equipmentsService.update(payload as any);
      if (resp?.state !== 'success') throw new Error(resp?.message ?? 'No se pudo guardar.');
      await this.customMessageService.open({ title: 'Éxito', type: 'success', message: 'Datos de almacenamiento guardados.', duration: 1600 });
      this.dialogRef.close(payload);
    } catch (e: any) {
      await this.customMessageService.open({ title: 'Error', type: 'error', message: e?.message ?? 'No se pudo guardar.', dismissBtn: true });
    } finally {
      this.saving.set(false);
    }
  }

  close(): void { this.dialogRef.close(); }
}
